import React, { useState } from "react";
import CreatableSelect from "react-select/creatable";
import { Button, Toggle } from "components/common";
import { useMutation } from "@apollo/react-hooks";
import { ISSUE_CREDIT } from "utils";
import { ERROR_STATUS } from "utils/constants";
import { modalBGColor } from "utils/customStyles";
import SuccessMessage from "components/Popups/Messages/SuccessMessage";

const IssueCreditModal = ({ user, refetch }) => {
  const creditTypes = [
    {
      value: "Q",
      label: "CS Initiated Credit (Q)",
    },
    {
      value: "br",
      label: "Recovery Load (br)",
    },
    {
      value: "RE",
      label: "Reimbursement (RE)",
    },
    {
      value: "ck",
      label: "Check payment (ck)",
    },
    {
      value: "PR",
      label: "PayPal payment (PR)",
    },
    {
      value: "fu",
      label: "Venmo payment (fu)",
    },
    {
      value: "cd",
      label: "Stripe payment (cd)",
    },
    {
      value: "ba",
      label: "Settlement Adjustment (ba)",
    },
  ];
  const [creditType, setCreditType] = useState(null);
  const [creditAmount, setCreditAmount] = useState("");
  const [creditNote, setCreditNote] = useState("");
  const [isDebit, setIsDebit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [issueCredit] = useMutation(ISSUE_CREDIT);

  const handleSubmit = async () => {
    setLoading(true);
    if (!creditType || !creditAmount) {
      setErrorMessage("Please enter a credit type and credit amount.");
      return;
    }

    const res = await issueCredit({
      variables: {
        email: user.email,
        amount: parseFloat(creditAmount),
        type: creditType.value,
        description: creditNote,
        isDebit,
      },
    });

    const {
      data: {
        issueCredit: { status },
      },
    } = res;
    if (status === ERROR_STATUS) {
      setErrorMessage(
        "There was an error issuing the credit. Please try again in 5 minutes.  If this persists, please reach out to dev-support.",
      );
      setLoading(false);
      return;
    }
    setLoading(false);
    setSuccess(true);
    refetch();
  };

  const handleChange = (e, fn, value) => {
    setErrorMessage("");
    setLoading(false);
    if (!value) {
      fn(e.target.value);
      return;
    }
    fn(value);
  };

  const WIDTH432 = { width: "432px" };
  const WIDTHANDBORDER = { width: "432px", border: "1px solid #e2e8f0" };

  return (
    <div style={modalBGColor} className="py-8 px-12">
      {success ? (
        <SuccessMessage
          mainMessage={`A credit for ${creditAmount} has been submitted.`}
        />
      ) : (
        <div
          style={{ width: "434px", height: "auto" }}
          className="flex flex-col justify-center items-center"
        >
          <div className="text-2xl w-96">Credit Type:</div>
          <CreatableSelect
            placeholder="Select credit type"
            value={creditType}
            options={creditTypes}
            className="w-full text-black"
            onChange={(type) => handleChange(null, setCreditType, type)}
          />
          <div style={WIDTH432} className="w-full text-2xl">
            Credit Amount
          </div>
          <div style={WIDTHANDBORDER} className="flex">
            <div className="flex items-center bg-white">
              <p className="text-2xl">$</p>
            </div>
            <input
              className="bg-white h-12 flex items-center text-2xl"
              style={WIDTH432}
              type="number"
              placeholder="0.00"
              onChange={(e) => handleChange(e, setCreditAmount)}
            />
          </div>
          <div className="w-full">
            <div className="my-auto">
              <span className="text-2xl mr-5">Postive adjustment</span>
              <Toggle
                active={isDebit}
                onChange={() => setIsDebit(!isDebit)}
              />
            </div>
            {isDebit && (<div className="text-red-600">{`WARN: This will increase the user's balance`}</div>)}
          </div>
          <div style={WIDTH432} className="w-full text-2xl">
            Credit Note
          </div>
          <textarea
            className="text-2xl"
            style={WIDTHANDBORDER}
            onChange={(e) => handleChange(e, setCreditNote)}
          />
          <div className={errorMessage ? "text-red-600 mb-4" : "hidden"}>
            {errorMessage}
          </div>
          <Button
            className={`mb-6 mt-5 w-36 text-2xl btn-green ${
              loading ? "opacity-50" : ""
            }`}
            disabled={loading}
            onClick={() => {
              handleSubmit();
            }}
          >
            Submit
          </Button>
        </div>
      )}
    </div>
  );
};

export default IssueCreditModal;
